import '../tenant-hierarchy/tenant-hierarchy.css';
import { JsonViewer } from '@textea/json-viewer';
import React from 'react';
import { Error } from '@app/shared';
import { ComponentErrorBoundary } from '@app/utilities';
import { useAggregatedRule } from '@app/sdk';

export function AggregatedConfigurations({ ouId, category }: { ouId: string; category: string }) {
  const { isLoading, data: rules, error } = useAggregatedRule({ ouId, category });

  return (
    <ComponentErrorBoundary>
      {error && <Error error={error} />}
      {isLoading && <div className="ui active centered inline loader" />}
      {!isLoading && <JsonViewer value={rules} />}
    </ComponentErrorBoundary>
  );
}
